import { Add, Folder, Public, PublicOff, Remove } from '@mui/icons-material';
import { TreeItem, TreeView } from '@mui/x-tree-view';
import React, { useEffect, useState } from 'react';
import { generateClassName } from '../../b2b-common/helpers';
import './LevelNsTree.css';
import { Badge, IconButton, TextField } from '@mui/material';
import { getIdFromLevelNsOrders, getMaxIdFromLevelNsOrders, getMinIdFromLevelNsOrders, getParentLevelNsIds, getParentLevelNsOrders, joinLevelNsIds } from './helper';

function LevelNsTree({ subLevels, className = null, onSelectedLevelN }) {
    const [minLevelNId, setMinLevelNId] = useState(null);
    const [maxLevelNId, setMaxLevelNId] = useState(null);
    const [filteredLevels, setFilteredLevels] = useState({
        l1: null,
        l2: null,
        l3: null,
        l4: null
    });
    const [filteredLevelIds, setFilteredLevelIds] = useState([]);
    const [showTranslation, setShowTranslation] = useState(false);

    const handleInputChange = (level, value) => {
        setFilteredLevels(prevLevels => ({ ...prevLevels, [level]: value }));
    };

    useEffect(() => {
        if (filteredLevels) {
            let levels = Object.values(filteredLevels);
            let validLevels = [];
            for (let level of levels) {
                if (level === null) break;
                validLevels.push(level);
            }
            if (validLevels.length > 0) {
                let minId = getMinIdFromLevelNsOrders(validLevels);
                let maxId = getMaxIdFromLevelNsOrders(validLevels);
                //console.log("validLevels: ", validLevels);
                setFilteredLevelIds(getParentLevelNsIds(minId))
                //console.log(`getParentLevelNsIds: ${filteredLevelIds}`);
                setMinLevelNId(minId);
                setMaxLevelNId(maxId);
                //console.log(`Min ID: ${minId}, Max ID: ${maxId}`);
            }
        }
    }, [filteredLevels]);

    const defaultExpandIcon = (
        <Badge badgeContent={<Add fontSize="small" />} color="primary">
            <Folder />
        </Badge>
    );

    const defaultRetractIcon = (
        <Badge badgeContent={<Remove fontSize="small" />} color="primary">
            <Folder />
        </Badge>
    );

    const handleSelectLevelN = (event, nodeId) => {
        //console.log("Selected LevelN: ", nodeId);
        if (onSelectedLevelN) {
            onSelectedLevelN(nodeId);
        }
    };

    const renderSubLevels = (subLevels) => {
        return subLevels.map((subLevel) => {
            if ((minLevelNId === null || subLevel.levelN_ItemId >= minLevelNId) &&
                (maxLevelNId === null || subLevel.levelN_ItemId <= maxLevelNId) ||
                (filteredLevelIds.includes(subLevel.levelN_ItemId))) {
                return subLevel.subLevels && subLevel.subLevels.length > 0 ?
                    (
                        <TreeItem
                            key={subLevel.levelN_ItemId}
                            nodeId={subLevel.levelN_ItemId.toString()}
                            label={`${joinLevelNsIds(getParentLevelNsOrders(subLevel.levelN_ItemId))} - ${(!showTranslation) ? subLevel.levelN_ItemName_label : subLevel.levelN_ItemName}`}
                            className={generateClassName("level-ns", "-tree-item", className)}
                            onClick={(event) => handleSelectLevelN(event, subLevel.levelN_ItemId)}
                        >
                            {subLevel.subLevels && subLevel.subLevels.length > 0 && renderSubLevels(subLevel.subLevels)}
                        </TreeItem>
                    ) :
                    (
                        <TreeItem
                            key={subLevel.levelN_ItemId}
                            nodeId={subLevel.levelN_ItemId.toString()}
                            label={`${joinLevelNsIds(getParentLevelNsOrders(subLevel.levelN_ItemId))} - ${(!showTranslation) ? subLevel.levelN_ItemName_label : subLevel.levelN_ItemName}`}
                            className={generateClassName("level-ns", "-tree-item", className)}
                            icon={<Folder />}
                            onClick={(event) => handleSelectLevelN(event, subLevel.levelN_ItemId)}
                        />
                    );
            }
            return null;
        });
    };

    const handleChangeToTranslation = () => {
        setShowTranslation(!showTranslation);
    }

    return (
        <>
            <div className={generateClassName("level-ns", "-tree-filter", className)}>
                <TextField id="l1" label="L1" variant="outlined" size='small' className='level-ns-tree-filter-level'
                    onChange={(e) => handleInputChange('l1', e.target.value)}
                />
                <TextField id="l2" label="L2" variant="outlined" size='small' className='level-ns-tree-filter-level'
                    onChange={(e) => handleInputChange('l2', e.target.value)}
                />
                <TextField id="l3" label="L3" variant="outlined" size='small' className='level-ns-tree-filter-level'
                    onChange={(e) => handleInputChange('l3', e.target.value)}
                />
                <TextField id="l4" label="L4" variant="outlined" size='small' className='level-ns-tree-filter-level'
                    onChange={(e) => handleInputChange('l4', e.target.value)}
                />
                <IconButton onClick={handleChangeToTranslation}>
                    {showTranslation ? <PublicOff /> : <Public />}
                </IconButton>
            </div>
            <TreeView
                defaultCollapseIcon={defaultRetractIcon}
                defaultExpandIcon={defaultExpandIcon}
                className={generateClassName("level-ns", "-tree", className)}>
                {renderSubLevels(subLevels)}
            </TreeView>
        </>
    );
}

export default LevelNsTree;